// Central place for data-testids used throughout the site.
export const NAV = {
  container: "site-nav",
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkApproach: "nav-link-approach",
  linkCredentials: "nav-link-credentials",
  linkFaq: "nav-link-faq",
  linkBook: "nav-link-book",
  ctaBook: "nav-cta-book",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  section: "hero-section",
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
  portrait: "hero-portrait",
};

export const ABOUT = { section: "about-section" };
export const APPROACH = { section: "approach-section" };
export const CREDENTIALS = { section: "credentials-section" };

export const FAQ = {
  section: "faq-section",
  item: (i) => `faq-item-${i}`,
  trigger: (i) => `faq-trigger-${i}`,
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  message: "contact-input-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const FOOTER = { container: "site-footer" };
